import mushroom from "mushroomjs";
import config from "../config.json";

mushroom._defineAsyncResource({
  name: "user",
  actions: {
    findMany: { clientCache: true },
    findById: { clientCache: true },
    createOne: {},
    updatePartially: {},
    deleteOne: {},
  },
  views: {},
});
mushroom._defineAsyncResource({
  name: "doanh_nghiep",
  actions: {
    findMany: { clientCache: true },
    findById: { clientCache: true },
    createOne: {},
    updatePartially: {},
    deleteOne: {},
    _raw_http_method_getDoanhNghiepGroupByNganhNghe: {},
  },
  views: {},
});
mushroom._defineAsyncResource({
  name: "tv_lien_he",
  actions: {
    findMany: { clientCache: true },
    findById: { clientCache: true },
    createOne: {},
    updatePartially: {},
    deleteOne: {},
  },
  views: {},
});
mushroom._defineAsyncResource({
  name: "nganh_nghe",
  actions: {
    findMany: { clientCache: true },
    findById: { clientCache: true },
    createOne: {},
    updatePartially: {},
    deleteOne: {},
    _raw_http_method_getNghanhNgheGroupByParent: {},
  },
  views: {},
});
mushroom._defineAsyncResource({
  name: "tv_quang_cao",
  actions: {
    findMany: { clientCache: true },
    findById: { clientCache: true },
    createOne: {},
    updatePartially: {},
    deleteOne: {},
  },
  views: {},
});
mushroom._defineAsyncResource({
  name: "lich_su_doanh_nghiep",
  actions: {
    findMany: { clientCache: true },
    findById: { clientCache: true },
    createOne: {},
    updatePartially: {},
    deleteOne: {},
  },
  views: {},
});
mushroom._defineAsyncResource({
  name: "tv_dich_vu_tour",
  actions: {
    findMany: { clientCache: true },
    findById: { clientCache: true },
    createOne: {},
    updatePartially: {},
    deleteOne: {},
  },
  views: {},
});
mushroom._defineAsyncResource({
  name: "tv_dich_vu_tour_cho_duyet",
  actions: {
    findMany: { clientCache: true },
    findById: { clientCache: true },
    createOne: {},
    updatePartially: {},
    deleteOne: {},
  },
  views: {},
});
mushroom._defineAsyncResource({
  name: "tv_diem_den",
  actions: {
    findMany: { clientCache: true },
    findById: { clientCache: true },
    createOne: {},
    updatePartially: {},
    deleteOne: {},
  },
  views: {},
});
mushroom._defineAsyncResource({
  name: "khachsan_nhahang",
  actions: {
    findMany: { clientCache: true },
    findById: { clientCache: true },
    createOne: {},
    updatePartially: {},
    deleteOne: {},
  },
  views: {},
});
mushroom._defineAsyncResource({
  name: "ve_may_bay",
  actions: {
    findMany: { clientCache: true },
    findById: { clientCache: true },
    createOne: {},
    updatePartially: {},
    deleteOne: {},
  },
  views: {},
});
mushroom._defineAsyncResource({
  name: "san_vat",
  actions: {
    findMany: { clientCache: true },
    findById: { clientCache: true },
    createOne: {},
    updatePartially: {},
    deleteOne: {},
  },
  views: {},
});
mushroom._defineAsyncResource({
  name: "tv_giai_tri",
  actions: {
    findMany: { clientCache: true },
    findById: { clientCache: true },
    createOne: {},
    updatePartially: {},
    deleteOne: {},
  },
  views: {},
});
mushroom._defineAsyncResource({
  name: "tv_dich_vu_luu_tru",
  actions: {
    findMany: { clientCache: true },
    findById: { clientCache: true },
    createOne: {},
    updatePartially: {},
    deleteOne: {},
  },
  views: {},
});
mushroom._defineAsyncResource({
  name: "tv_ve_dien_tu",
  actions: {
    findMany: { clientCache: true },
    findById: { clientCache: true },
    createOne: {},
    updatePartially: {},
    deleteOne: {},
  },
  views: {},
});
mushroom._defineAsyncResource({
  name: "khach_du_lich",
  actions: {
    findMany: { clientCache: true },
    findById: { clientCache: true },
    createOne: {},
    updatePartially: {},
    deleteOne: {},
  },
  views: {},
});
mushroom._defineAsyncResource({
  name: "diem_den_an_toan",
  actions: { findMany: { clientCache: true }, findById: { clientCache: true } },
  views: {},
});
mushroom._defineAsyncResource({
  name: "province",
  actions: { findMany: { clientCache: true }, findById: { clientCache: true } },
  views: {},
});
mushroom._defineAsyncResource({
  name: "district",
  actions: { findMany: { clientCache: true }, findById: { clientCache: true } },
  views: {},
});
mushroom._defineAsyncResource({
  name: "commune",
  actions: { findMany: { clientCache: true }, findById: { clientCache: true } },
  views: {},
});
mushroom._defineAsyncResource({
  name: "tv_tin_tuc",
  actions: {
    findMany: { clientCache: true },
    findById: { clientCache: true },
    createOne: {},
    updatePartially: {},
    deleteOne: {},
    _raw_http_method_getNguoiTao: {},
  },
  views: {},
});
mushroom._defineAsyncResource({
  name: "tv_am_thuc",
  actions: {
    findMany: { clientCache: true },
    findById: { clientCache: true },
    createOne: {},
    updatePartially: {},
    deleteOne: {},
  },
  views: {},
});
mushroom._defineAsyncResource({
  name: "cong_ty_lu_hanh",
  actions: { findMany: { clientCache: true }, findById: { clientCache: true } },
  views: {},
});
mushroom._defineAsyncResource({
  name: "tv_phan_hoi",
  actions: {
    findMany: { clientCache: true },
    findById: { clientCache: true },
    createOne: {},
    updatePartially: {},
    deleteOne: {},
  },
  views: {},
});
mushroom._defineAsyncResource({
  name: "profile",
  actions: {
    findMany: { clientCache: true },
    findById: { clientCache: true },
    updatePartially: {},
  },
  views: {},
});
mushroom._defineAsyncResource({
  name: "tv_info_diem_den",
  actions: {
    findMany: { clientCache: true },
    findById: { clientCache: true },
    createOne: {},
    updatePartially: {},
    deleteOne: {},
  },
  views: {},
});
mushroom._defineAsyncResource({
  name: "tv_info_ve_dien_tu",
  actions: {
    findMany: { clientCache: true },
    findById: { clientCache: true },
    createOne: {},
    updatePartially: {},
    deleteOne: {},
  },
  views: {},
});
mushroom._defineAsyncResource({
  name: "tv_nen_tang_dich_vu",
  actions: {
    findMany: { clientCache: true },
    findById: { clientCache: true },
    createOne: {},
    updatePartially: {},
    deleteOne: {},
  },
  views: {},
});
mushroom._defineAsyncResource({
  name: "tv_don_vi_cung_cap",
  actions: {
    findMany: { clientCache: true },
    findById: { clientCache: true },
    createOne: {},
    updatePartially: {},
    deleteOne: {},
  },
  views: {},
});
mushroom._defineAsyncResource({
  name: "tv_don_vi_cung_cap_cho_duyet",
  actions: {
    findMany: { clientCache: false },
    findById: { clientCache: false },
    createOne: {},
    updatePartially: {},
    deleteOne: {},
  },
  views: {},
});
mushroom._defineAsyncResource({
  name: "tv_dich_vu",
  actions: {
    findMany: { clientCache: false },
    findById: { clientCache: false },
    createOne: {},
    updatePartially: {},
    deleteOne: {},
  },
  views: {},
});
mushroom._defineAsyncResource({
  name: "tv_dich_vu_cho_duyet",
  actions: {
    findMany: { clientCache: false },
    findById: { clientCache: false },
    createOne: {},
    updatePartially: {},
    deleteOne: {},
  },
  views: {},
});
mushroom._defineAsyncResource({
  name: "tv_dich_vu_am_thuc",
  actions: {
    findMany: { clientCache: false },
    findById: { clientCache: false },
  },
  views: {},
});
mushroom._defineAsyncResource({
  name: "tv_gioi_thieu",
  actions: {
    findMany: { clientCache: false },
    findById: { clientCache: false },
    createOne: {},
    updatePartially: {},
    deleteOne: {},
  },
  views: {},
});
mushroom._defineAsyncResource({
  name: "tv_nguon_tin_tuc",
  actions: {
    findMany: { clientCache: false },
    findById: { clientCache: false },
    createOne: {},
    updatePartially: {},
    deleteOne: {},
  },
  views: {},
});
mushroom._defineAsyncResource({
  name: "tv_dich_vu_quang_cao",
  actions: {
    findMany: { clientCache: false },
    findById: { clientCache: false },
    createOne: {},
    updatePartially: {},
    deleteOne: {},
  },
  views: {},
});
mushroom._defineAsyncResource({
  name: "tv_danh_gia",
  actions: {
    findMany: { clientCache: false },
    findById: { clientCache: false },
    createOne: {},
    updatePartially: {},
    deleteOne: {},
  },
  views: { suggest_response_user: {}, suggest_response_dichvu: {} },
});
mushroom._defineAsyncResource({
  name: "tv_cong_ty_lu_hanh",
  actions: { findMany: { clientCache: true }, findById: { clientCache: true } },
  views: {},
});
mushroom._defineAsyncResource({
  name: "file",
  actions: { findMany: { clientCache: true }, findById: { clientCache: true } },
  views: {},
});
mushroom._defineAsyncResource({
  name: "diem_den_an_toan_check_in",
  actions: { findMany: { clientCache: true }, findById: { clientCache: true } },
  views: {},
});
mushroom._defineAsyncResource({
  name: "dang_ky_chuong_trinh",
  actions: {
    findMany: { clientCache: false },
    findById: { clientCache: false },
    createOne: {},
    updatePartially: {},
    deleteOne: {},
  },
  views: {},
});
mushroom.user.getRolesAsync = function (body) {
  let fn = mushroom.__createAsyncRestFunction({
    name: "user.getRoles",
    method: "POST",
    blankBody: false,
    headers: {
      "X-HTTP-Method-Override": "getRoles",
    },
    url: mushroom._fnGetRootApiUrl() + "users/getRoles",
  });
  return fn(body);
};

mushroom.tv_don_vi_cung_cap_cho_duyet.approvedDonViAsync = function (body) {
  let fn = mushroom.__createAsyncRestFunction({
    resource: "tv_don_vi_cung_cap_cho_duyet",
    method: "POST",
    blankBody: false,
    headers: {
      "X-HTTP-Method-Override": "approvedDonVi",
    },
    url:
      mushroom._fnGetRootApiUrl() +
      "tv_don_vi_cung_cap_cho_duyets/approvedDonVi",
    connection: mushroom.tv_don_vi_cung_cap_cho_duyet,
    name: "approvedDonVi",
    clearCache: true,
  });
  return fn(body);
};

mushroom.tv_dich_vu_cho_duyet.approvedDichVuAsync = function (body) {
  let fn = mushroom.__createAsyncRestFunction({
    resource: "tv_dich_vu_cho_duyet",
    method: "POST",
    blankBody: false,
    headers: {
      "X-HTTP-Method-Override": "approvedDichVu",
    },
    url: mushroom._fnGetRootApiUrl() + "tv_dich_vu_cho_duyets/approvedDichVu",
    connection: mushroom.tv_dich_vu_cho_duyet,
    name: "approvedDichVu",
    clearCache: true,
  });
  return fn(body);
};

mushroom.tv_dich_vu.unApprovedDichVuAsync = function (body) {
  let fn = mushroom.__createAsyncRestFunction({
    resource: "tv_dich_vu",
    method: "POST",
    blankBody: false,
    headers: {
      "X-HTTP-Method-Override": "unApprovedDichVu",
    },
    url: mushroom._fnGetRootApiUrl() + "tv_dich_vus/unApprovedDichVu",
    connection: mushroom.tv_dich_vu,
    name: "unApprovedDichVu",
    clearCache: true,
  });
  return fn(body);
};

mushroom.tv_tin_tuc.getNguoiTaoAsync = function () {
  let fn = mushroom.__createAsyncRestFunction({
    resource: "tv_tin_tuc",
    method: "POST",
    blankBody: false,
    headers: {
      "X-HTTP-Method-Override": "getNguoiTao",
    },
    url: mushroom._fnGetRootApiUrl() + "tv_tin_tucs/getNguoiTao",
    connection: mushroom.tv_tin_tuc,
    name: "getNguoiTao",
    clearCache: true,
  });
  return fn();
};

mushroom.tv_dich_vu_tour_cho_duyet.approvedDichVuTourAsync = function (body) {
  let fn = mushroom.__createAsyncRestFunction({
    resource: "tv_dich_vu_tour_cho_duyet",
    method: "POST",
    blankBody: false,
    headers: {
      "X-HTTP-Method-Override": "approvedDichVuTour",
    },
    url:
      mushroom._fnGetRootApiUrl() +
      "tv_dich_vu_tour_cho_duyets/approvedDichVuTour",
    connection: mushroom.tv_dich_vu_tour_cho_duyet,
    name: "approvedDichVuTour",
    clearCache: true,
  });
  return fn(body);
};

mushroom.tv_dich_vu_tour.unApprovedDichVuAsync = function (body) {
  let fn = mushroom.__createAsyncRestFunction({
    resource: "tv_dich_vu_tour",
    method: "POST",
    blankBody: false,
    headers: {
      "X-HTTP-Method-Override": "unApprovedDichVu",
    },
    url: mushroom._fnGetRootApiUrl() + "tv_dich_vu_tours/unApprovedDichVu",
    connection: mushroom.tv_dich_vu_tour,
    name: "unApprovedDichVu",
    clearCache: true,
  });
  return fn(body);
};

mushroom.tv_don_vi_cung_cap_cho_duyet.registerTrangVangAsync = function (body) {
  let fn = mushroom.__createAsyncRestFunction({
    resource: "tv_don_vi_cung_cap_cho_duyet",
    method: "POST",
    blankBody: false,
    headers: {
      "X-HTTP-Method-Override": "registerTrangVang",
    },
    url:
      mushroom._fnGetRootApiUrl() +
      "tv_don_vi_cung_cap_cho_duyets/registerTrangVang",
    connection: mushroom.tv_don_vi_cung_cap_cho_duyet,
    name: "registerTrangVang",
    clearCache: true,
  });
  return fn(body);
};

mushroom.tv_don_vi_cung_cap_cho_duyet.updateEmailAsync = function (body) {
  let fn = mushroom.__createAsyncRestFunction({
    resource: "tv_don_vi_cung_cap_cho_duyet",
    method: "POST",
    blankBody: false,
    headers: {
      "X-HTTP-Method-Override": "updateEmail",
    },
    url:
      mushroom._fnGetRootApiUrl() + "tv_don_vi_cung_cap_cho_duyets/updateEmail",
    connection: mushroom.tv_don_vi_cung_cap_cho_duyet,
    name: "updateEmail",
    clearCache: true,
  });
  return fn(body);
};

mushroom.diem_den_an_toan.update_uu_daiAsync = function (body) {
  let fn = mushroom.__createAsyncRestFunction({
    resource: "diem_den_an_toan",
    method: "POST",
    blankBody: false,
    headers: {
      "X-HTTP-Method-Override": "update_uu_dai",
    },
    url: mushroom._fnGetRootApiUrl() + "diem_den_an_toans/update_uu_dai",
    connection: mushroom.diem_den_an_toan,
    name: "update_uu_dai",
    clearCache: true,
  });
  return fn(body);
};

mushroom.diem_den_an_toan.update_hdv_uu_daiAsync = function (body) {
  let fn = mushroom.__createAsyncRestFunction({
    resource: "diem_den_an_toan",
    method: "POST",
    blankBody: false,
    headers: {
      "X-HTTP-Method-Override": "update_hdv_uu_dai",
    },
    url: mushroom._fnGetRootApiUrl() + "diem_den_an_toans/update_hdv_uu_dai",
    connection: mushroom.diem_den_an_toan,
    name: "update_hdv_uu_dai",
    clearCache: true,
  });
  return fn(body);
};

mushroom.diem_den_an_toan.update_album_imageAsync = function (body) {
  let fn = mushroom.__createAsyncRestFunction({
    resource: "diem_den_an_toan",
    method: "POST",
    blankBody: false,
    headers: {
      "X-HTTP-Method-Override": "update_album_image",
    },
    url: mushroom._fnGetRootApiUrl() + "diem_den_an_toans/update_album_image",
    connection: mushroom.diem_den_an_toan,
    name: "update_album_image",
    clearCache: true,
  });
  return fn(body);
};

mushroom.tv_cong_ty_lu_hanh.update_hdv_uu_daiAsync = function (body) {
  let fn = mushroom.__createAsyncRestFunction({
    resource: "tv_cong_ty_lu_hanh",
    method: "POST",
    blankBody: false,
    headers: {
      "X-HTTP-Method-Override": "update_hdv_uu_dai",
    },
    url: mushroom._fnGetRootApiUrl() + "tv_cong_ty_lu_hanhs/update_hdv_uu_dai",
    connection: mushroom.tv_cong_ty_lu_hanh,
    name: "update_hdv_uu_dai",
    clearCache: true,
  });
  return fn(body);
};

mushroom.dang_ky_chuong_trinh.approveAsync = function (body) {
  let fn = mushroom.__createAsyncRestFunction({
    resource: "dang_ky_chuong_trinh",
    method: "POST",
    blankBody: false,
    headers: {
      "X-HTTP-Method-Override": "approve",
    },
    url: mushroom._fnGetRootApiUrl() + "dang_ky_chuong_trinhs/approve",
    connection: mushroom.dang_ky_chuong_trinh,
    name: "approve",
    clearCache: true,
  });
  return fn(body);
};

mushroom.dang_ky_chuong_trinh.rejectAsync = function (body) {
  let fn = mushroom.__createAsyncRestFunction({
    resource: "dang_ky_chuong_trinh",
    method: "POST",
    blankBody: false,
    headers: {
      "X-HTTP-Method-Override": "reject",
    },
    url: mushroom._fnGetRootApiUrl() + "dang_ky_chuong_trinhs/reject",
    connection: mushroom.dang_ky_chuong_trinh,
    name: "reject",
    clearCache: true,
  });
  return fn(body);
};

mushroom.$using(config.hostApiTrangVang + "api/v1/");
export default mushroom;
